import { render } from "./ModalFirmaIntervento.vue?vue&type=template&id=c5b1480e&scoped=true&ts=true"
import script from "./ModalFirmaIntervento.vue?vue&type=script&lang=ts"
export * from "./ModalFirmaIntervento.vue?vue&type=script&lang=ts"

import "./ModalFirmaIntervento.vue?vue&type=style&index=0&id=c5b1480e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b1480e"]])

export default __exports__